// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @19.06.2017 15:21:15
import { ListMapLayers_abstract } from './../../abstract/SagaSchema/ListObjects/ListMapLayers_abstract';
export class ListMapLayers extends ListMapLayers_abstract {}
